module.exports = __webpack_public_path__ + "9bf3d0809190595c0ce814682e6ec378.fbx";